export default function profileSubNavSelector(store) {
	return {
		...store.subNavs
	};
}